import { createApp } from 'vue';
import App from './App.vue';
import { createVuetify } from 'vuetify';
import 'vuetify/styles';
import '@mdi/font/css/materialdesignicons.css';
import '@fortawesome/fontawesome-free/css/all.css';
import store from './store';
import router from './router';

const vuetify = createVuetify();

createApp(App)
    .use(vuetify)
    .use(store)
    .use(router)
    .mount('#app');
